import _ from 'lodash';

const needAclCheckMap = {
    pdf: 'pdf',
    valuation: 'patentValue',
    litigation: 'litigation',
    rerexam: 'reexamInvalid',
    licensing: 'licensing',
    pledge: 'pledge',
    fireWrapper: 'fileWrapper',
    customs: 'customsData',
    'patent-family': 'family',
    similar: 'mlt',
    literature: 'paper',
};

export const checkAclByName = (name, permissions) => {
    return _.get(permissions, needAclCheckMap[name], true);
};
